import React from 'react';
import { PLAYER_THEME_VARS } from '../../theme';
import '../../primitives/tome/tome-tokens.css';
import './EntryScreens.css';

/** One parchment leaf on the book's dark cover, for every step before the roster. */
export const EntryPanel: React.FC<{ children: React.ReactNode; wide?: boolean; label: string; actions?: React.ReactNode }> = ({ children, wide, label, actions }) => (
  <main className={`entry-screen tome-tokens ${wide ? 'entry-screen--wide' : ''}`} style={PLAYER_THEME_VARS} aria-label={label}>
    <div className="entry-screen__brand">Helix 2000</div>
    <div className="entry-screen__body">{children}</div>
    {actions && <footer className="entry-screen__footer">{actions}</footer>}
  </main>
);
